<app-header-translator></app-header-translator>
<app-premium-spotlight 
     [policytype]="policytype"
     [zipCode]="quoterRequest.ZipCode"
     [startYear]="quoterRequest.StartYear"
     [isPolicyTypeChoice]="(policytype === modules.homeowner && (!calcInput.PersonalPropertyCoverage || (calcInput.PersonalPropertyDeductible !== 0 && calcInput.PersonalPropertyDeductible !== null))) || (policytype === modules.mobilehome  && (!calcInput.PersonalPropertyCoverage || (calcInput.PersonalPropertyDeductible !== 0 && calcInput.PersonalPropertyDeductible !== null)))"
     [processing]="processing"
     [gaugeValue]="gaugeValue"
     [annualPremium]="showError ? 0 : quoterResponse?.AnnualPremium">  
</app-premium-spotlight>

<div class="cea-page" id="cea-page-1">
  <div class="cea-main-view ng-scope" ui-view="">
    <form name="theForm" novalidate="" class="ng-pristine ng-valid ng-scope">
      <div class="row cea-form">
        <div class="cea-col-sm-12 cea-col-md-12 offset-md-0 offset-sm-0">
          <div id="form-container">
            <div id="form-views" ui-view="" class="ng-scope">

                <div class="cea-alternate cea-interactive slider-view"
                     *ngIf="policytype === modules.homeowner">

                    <div class="cea-standout-container mb-4" 
                         *ngIf="showRetrofitNotice">
                         <h3 class="cea-standout-text">
                              {{'HOMEOWNERS.CALCULATIONS.RETROFIT_GRANT' | translate }}
                              <a 
                                   href="{{eqaUrl | lowercase}}{{'GLOBAL.BRACEBOLT_GRANT_URL' | translate | lowercase}}" 
                                   target="_parent">
                                   {{'HOMEOWNERS.CALCULATIONS.RETROFIT_LINK' | translate}}
                              </a>
                         </h3>
                    </div>

                    <div app-cea-slider-bootstrap
                         class="slider-container"
                         [sliderSettings]="DwellingDeductibleVariableSlider"
                         (setSliderValue)="setSliderValue($event, 'BuildingPropertyDeductible')">
                    </div>

                    <div app-cea-slider-bootstrap
                         class="slider-container"
                         [sliderSettings]="BuildingPropertyCoverageVariableSlider"
                         (setSliderValue)="setSliderValue($event)">                         
                    </div>

                    <!-- <div app-cea-radio-group (setRadioValue)="setSliderValue($event)" (moveTop)="moveTop($event)"
                         [radioGroupSettings]="BuildingCodeUpgradeIncreasedLimitRadioGroup"
                         *ngIf="!frfMode" class="form-group"></div> -->

                    <div app-cea-radio-group-bootstrap
                         *ngIf="!frfMode"
                         (setRadioValue)="setSliderValue($event)"
                         [radioGroupSettings]="BuildingCodeUpgradeIncreasedLimitRadioGroup"
                         class="slider-container">                         
                    </div>

                    <div app-cea-slider-bootstrap
                         class="slider-container"
                         [sliderSettings]="PersonalPropertyCoverageVariableSlider"
                         (setSliderValue)="setSliderValue($event, 'PersonalPropertyCoverage')">                         
                    </div>

                    <div app-cea-slider-bootstrap
                         *ngIf="!showPersonalPropertyDeductibleVariableSliderFake"
                         class="slider-container"
                         [sliderSettings]="PersonalPropertyDeductibleVariableSlider"
                         (setSliderValue)="setSliderValue($event, 'PersonalPropertyDeductible')">                         
                    </div>

                    <!-- <div app-cea-slider [sliderSettings]="PersonalPropertyDeductibleVariableSlider"
                         class="form-group" (moveTop)="moveTop($event)"
                         (setSliderValue)="setSliderValue($event,'PersonalPropertyDeductible')"
                         *ngIf="!showPersonalPropertyDeductibleVariableSliderFake"></div> -->

                    <div app-cea-slider-bootstrap
                         *ngIf="showPersonalPropertyDeductibleVariableSliderFake"
                         class="slider-container"
                         [sliderSettings]="PersonalPropertyDeductibleVariableSlider"
                         (setSliderValue)="setSliderValue($event, 'PersonalPropertyDeductible')">                            
                    </div>

                    <!-- <div app-cea-slider [sliderSettings]="PersonalPropertyDeductibleVariableSlider"
                         class="form-group" (moveTop)="moveTop($event)"
                         (setSliderValue)="setSliderValue($event,'PersonalPropertyDeductible')"
                         *ngIf="showPersonalPropertyDeductibleVariableSliderFake"></div> -->


<!-- 
                    <div app-cea-radio-group (setRadioValue)="setSliderValue($event)"
                         (moveTop)="moveTop($event)" [radioGroupSettings]="WantsBreakableCoverageRadioGroup"
                         *ngIf="!showWantsBreakableCoverageRadioGroupFake && !frfMode" class="form-group"></div> -->

                    <div app-cea-radio-group-bootstrap
                         *ngIf="!showWantsBreakableCoverageRadioGroupFake && !frfMode"
                         (setRadioValue)="setSliderValue($event)"
                         [radioGroupSettings]="WantsBreakableCoverageRadioGroup"
                         class="slider-container">                         
                    </div>


                    <!-- <div app-cea-radio-group (setRadioValue)="setSliderValue($event)"
                         [radioGroupSettings]="WantsBreakableCoverageRadioGroupFake"
                         (moveTop)="moveTop($event)" *ngIf="showWantsBreakableCoverageRadioGroupFake && !frfMode"
                         class="form-group"></div> -->

                    <div app-cea-radio-group-bootstrap
                         *ngIf="showWantsBreakableCoverageRadioGroupFake && !frfMode"
                         (setRadioValue)="setSliderValue($event)"
                         [radioGroupSettings]="WantsBreakableCoverageRadioGroupFake"
                         class="slider-container">                         
                    </div>

                    <div app-cea-slider-bootstrap
                         *ngIf="!showLossOfUseCoverageVariableSlider1"
                         class="slider-container"
                         [sliderSettings]="LossOfUseCoverageVariableSlider"
                         (setSliderValue)="setSliderValue($event)">                         
                    </div>

                    <!-- <div app-cea-slider [sliderSettings]="LossOfUseCoverageVariableSlider"
                         (moveTop)="moveTop($event)" class="form-group"
                         (setSliderValue)="setSliderValue($event)"
                         *ngIf="!showLossOfUseCoverageVariableSlider1"></div> -->

                    <div app-cea-slider-bootstrap
                         *ngIf="showLossOfUseCoverageVariableSlider1"
                         class="slider-container"
                         [sliderSettings]="LossOfUseCoverageVariableSlider1"
                         (setSliderValue)="setSliderValue($event)">                         
                    </div>
                    
                    <!-- <div app-cea-slider [sliderSettings]="LossOfUseCoverageVariableSlider1"
                         (moveTop)="moveTop($event)" class="form-group"
                         (setSliderValue)="setSliderValue($event)"
                         *ngIf="showLossOfUseCoverageVariableSlider1"></div> -->

                </div>


               <div class="cea-alternate cea-interactive slider-view" 
                    *ngIf="policytype === modules.condo">

                <!-- <div app-cea-slider [sliderSettings]="BuildingPropertyCoverageVariableSlider"
                     class="form-group" (moveTop)="moveTop($event)"
                     (setSliderValue)="setSliderValue($event,'BuildingPropertyCoverage')"></div> -->

                    <div app-cea-slider-bootstrap
                         [sliderSettings]="BuildingPropertyCoverageVariableSlider"
                         class="slider-container"
                         (setSliderValue)="setSliderValue($event, 'BuildingPropertyCoverage')">                    
                    </div>
     <!-- 
                    <div app-cea-slider [sliderSettings]="BuildingPropertyDeductibleVariableSlider"
                         class="form-group" (moveTop)="moveTop($event)"
                         (setSliderValue)="setSliderValue($event,'BuildingPropertyDeductible')"
                         *ngIf="showBuildingPropertyDeductibleVariableSliderFake === false"></div> -->

                    <div app-cea-slider-bootstrap
                         *ngIf="showBuildingPropertyDeductibleVariableSliderFake === false"
                         [sliderSettings]="BuildingPropertyDeductibleVariableSlider"
                         class="slider-container"
                         (setSliderValue)="setSliderValue($event, 'BuildingPropertyDeductible')">                    
                    </div>

                    <!-- <div app-cea-slider [sliderSettings]="BuildingPropertyDeductibleVariableSliderFake"
                         (moveTop)="moveTop($event)" class="form-group"
                         (setSliderValue)="setSliderValue($event,'BuildingPropertyDeductible')"
                         *ngIf="showBuildingPropertyDeductibleVariableSliderFake === true"></div> -->

                    <div app-cea-slider-bootstrap
                         *ngIf="showBuildingPropertyDeductibleVariableSliderFake === true"
                         [sliderSettings]="BuildingPropertyDeductibleVariableSliderFake"
                         class="slider-container"
                         (setSliderValue)="setSliderValue($event,'BuildingPropertyDeductible')">                    
                    </div>

                    <!-- <div app-cea-slider [sliderSettings]="PersonalPropertyCoverageVariableSlider"
                         (moveTop)="moveTop($event)" class="form-group"
                         (setSliderValue)="setSliderValue($event,'PersonalProperty')"
                         *ngIf="refreshPersonalPropertyCoverageVariableSlider === true"></div> -->

                    <div app-cea-slider-bootstrap
                         *ngIf="refreshPersonalPropertyCoverageVariableSlider === true"
                         [sliderSettings]="PersonalPropertyCoverageVariableSlider"
                         class="slider-container"
                         (setSliderValue)="setSliderValue($event,'PersonalProperty')">                    
                    </div>

                    <!-- <div app-cea-slider [sliderSettings]="PersonalPropertyCoverageVariableSlider"
                         (moveTop)="moveTop($event)" class="form-group"
                         (setSliderValue)="setSliderValue($event,'PersonalProperty')"
                         *ngIf="refreshPersonalPropertyCoverageVariableSlider === false"></div> -->

                    <div app-cea-slider-bootstrap
                         *ngIf="refreshPersonalPropertyCoverageVariableSlider === false"
                         [sliderSettings]="PersonalPropertyCoverageVariableSlider"
                         class="slider-container"
                         (setSliderValue)="setSliderValue($event,'PersonalProperty')">
                    </div>

                    <!-- <div app-cea-slider [sliderSettings]="PersonalPropertyDeductibleVariableSlider"
                         (moveTop)="moveTop($event)" class="form-group"
                         (setSliderValue)="setSliderValue($event,'PersonalPropertyDeductible')"
                         *ngIf="showPersonalPropertyDeductibleVariableSliderFake === false"></div> -->

                    <div app-cea-slider-bootstrap
                         *ngIf="showPersonalPropertyDeductibleVariableSliderFake === false"
                         [sliderSettings]="PersonalPropertyDeductibleVariableSlider"
                         class="slider-container"
                         (setSliderValue)="setSliderValue($event,'PersonalPropertyDeductible')">
                    </div>

                    <!-- <div app-cea-slider [sliderSettings]="PersonalPropertyDeductibleVariableSliderFake"
                         (moveTop)="moveTop($event)" class="form-group"
                         (setSliderValue)="setSliderValue($event,'PersonalPropertyDeductible')"
                         *ngIf="showPersonalPropertyDeductibleVariableSliderFake === true"></div> -->

                    <div app-cea-slider-bootstrap
                         *ngIf="showPersonalPropertyDeductibleVariableSliderFake === true"
                         [sliderSettings]="PersonalPropertyDeductibleVariableSliderFake"
                         class="slider-container"
                         (setSliderValue)="setSliderValue($event,'PersonalPropertyDeductible')">
                    </div>

                    <!-- <div app-cea-radio-group
                         (setRadioValue)="setSliderValue($event,'WantsBreakableCoverage')"
                         (moveTop)="moveTop($event)" [radioGroupSettings]="WantsBreakableCoverageRadioGroup"
                         *ngIf="showWantsBreakableCoverageRadioGroupFake === false && !frfMode" class="form-group"></div> -->

                    <div app-cea-radio-group-bootstrap
                         *ngIf="showWantsBreakableCoverageRadioGroupFake === false && !frfMode"
                         [radioGroupSettings]="WantsBreakableCoverageRadioGroup"
                         class="slider-container"
                         (setRadioValue)="setSliderValue($event,'WantsBreakableCoverage')">
                    </div>

                    <!-- <div app-cea-radio-group
                         (setRadioValue)="setSliderValue($event,'WantsBreakableCoverage')"
                         [radioGroupSettings]="WantsBreakableCoverageRadioGroupFake"
                         (moveTop)="moveTop($event)"
                         *ngIf="showWantsBreakableCoverageRadioGroupFake === true && !frfMode" class="form-group"></div> -->

                    <div app-cea-radio-group-bootstrap
                         *ngIf="showWantsBreakableCoverageRadioGroupFake === true && !frfMode"
                         [radioGroupSettings]="WantsBreakableCoverageRadioGroupFake"
                         class="slider-container"
                         (setRadioValue)="setSliderValue($event,'WantsBreakableCoverage')">
                    </div>

                    <!-- <div app-cea-slider [sliderSettings]="LossOfUseCoverageVariableSlider"
                         (moveTop)="moveTop($event)" class="form-group"
                         (setSliderValue)="setSliderValue($event,'LossOfUseCoverage')"
                         *ngIf="refreshLossOfUseCoverageVariableSlider === true"></div> -->

                    <div app-cea-slider-bootstrap
                         *ngIf="refreshLossOfUseCoverageVariableSlider === true"
                         [sliderSettings]="LossOfUseCoverageVariableSlider"
                         class="slider-container"
                         (setSliderValue)="setSliderValue($event,'LossOfUseCoverage')">
                    </div>

                    <!-- <div app-cea-slider [sliderSettings]="LossOfUseCoverageVariableSlider"
                         (moveTop)="moveTop($event)" class="form-group"
                         (setSliderValue)="setSliderValue($event,'LossOfUseCoverage')"
                         *ngIf="refreshLossOfUseCoverageVariableSlider === false"></div> -->

                    <div app-cea-slider-bootstrap
                         *ngIf="refreshLossOfUseCoverageVariableSlider === false"
                         [sliderSettings]="LossOfUseCoverageVariableSlider"
                         class="slider-container"
                         (setSliderValue)="setSliderValue($event,'LossOfUseCoverage')">
                    </div>

                    <!-- <div app-cea-slider [sliderSettings]="LossAssessmentCoverageVariableSlider"
                         class="form-group" (moveTop)="moveTop($event)"
                         (setSliderValue)="setSliderValue($event,'LossAssessmentCoverage')"></div> -->

                    <div app-cea-slider-bootstrap
                         [sliderSettings]="LossAssessmentCoverageVariableSlider"
                         class="slider-container"
                         (setSliderValue)="setSliderValue($event,'LossAssessmentCoverage')">                    
                    </div>

                    <!-- <div app-cea-slider [sliderSettings]="LossAssessmentDeductibleVariableSlider"
                         (moveTop)="moveTop($event)" class="form-group"
                         *ngIf="showLossAssessmentDeductibleVariableSliderFake === false"
                         (setSliderValue)="setSliderValue($event,'LossAssessmentDeductible')"></div> -->

                    <div app-cea-slider-bootstrap
                         *ngIf="showLossAssessmentDeductibleVariableSliderFake === false"
                         [sliderSettings]="LossAssessmentDeductibleVariableSlider"
                         class="slider-container"
                         (setSliderValue)="setSliderValue($event,'LossAssessmentDeductible')">                    
                    </div>

                    <!-- <div app-cea-slider [sliderSettings]="LossAssessmentDeductibleVariableSliderFake"
                         (moveTop)="moveTop($event)" class="form-group"
                         *ngIf="showLossAssessmentDeductibleVariableSliderFake === true"
                         (setSliderValue)="setSliderValue($event)"></div> -->

                    <div app-cea-slider-bootstrap
                         *ngIf="showLossAssessmentDeductibleVariableSliderFake === true"
                         [sliderSettings]="LossAssessmentDeductibleVariableSliderFake"
                         class="slider-container"
                         (setSliderValue)="setSliderValue($event)">                    
                    </div>                  

               </div>

              <div class="cea-alternate cea-interactive slider-view"
                   *ngIf="policytype === modules.renter">                    

                    <!-- <div app-cea-slider [sliderSettings]="PersonalPropertyCoverageVariableSlider"
                         (moveTop)="moveTop($event)" class="form-group"
                         (setSliderValue)="setSliderValue($event)"></div> -->

                    <div app-cea-slider-bootstrap
                         [sliderSettings]="PersonalPropertyCoverageVariableSlider"
                         class="slider-container"
                         (setSliderValue)="setSliderValue($event)">
                    </div>

                    <!-- <div app-cea-slider [sliderSettings]="PersonalPropertyDeductibleVariableSlider"
                         (moveTop)="moveTop($event)" class="form-group"
                         (setSliderValue)="setSliderValue($event)"></div> -->

                    <div app-cea-slider-bootstrap
                         [sliderSettings]="PersonalPropertyDeductibleVariableSlider"
                         class="slider-container"
                         (setSliderValue)="setSliderValue($event)">                         
                    </div>

                    <!-- <div app-cea-radio-group (setRadioValue)="setSliderValue($event)"
                         (moveTop)="moveTop($event)" [radioGroupSettings]="WantsBreakableCoverageRadioGroup"
                         class="form-group"
                         *ngIf="!frfMode"></div> -->

                    <div app-cea-radio-group-bootstrap
                         *ngIf="!frfMode"
                         [radioGroupSettings]="WantsBreakableCoverageRadioGroup"
                         class="slider-container"
                         (setRadioValue)="setSliderValue($event)">                         
                    </div>

                    <!-- <div app-cea-slider [sliderSettings]="LossOfUseCoverageVariableSlider"
                         (moveTop)="moveTop($event)" class="form-group"
                         (setSliderValue)="setSliderValue($event)"></div> -->

                    <div app-cea-slider-bootstrap
                         [sliderSettings]="LossOfUseCoverageVariableSlider"
                         class="slider-container"
                         (setSliderValue)="setSliderValue($event)">                         
                    </div>
              </div>

              <div class="cea-alternate cea-interactive slider-view"
                   *ngIf="policytype === modules.mobilehome">

                    <!-- <div app-cea-slider [sliderSettings]="DwellingDeductibleVariableSlider"
                         class="form-group" (moveTop)="moveTop($event)"
                         (setSliderValue)="setSliderValue($event,'BuildingPropertyDeductible')"></div> -->

                    <div app-cea-slider-bootstrap
                         [sliderSettings]="DwellingDeductibleVariableSlider"
                         class="slider-container"
                         (setSliderValue)="setSliderValue($event,'BuildingPropertyDeductible')">                         
                    </div>

                    <!-- <div app-cea-slider [sliderSettings]="BCUCoverageVariableSlider" class="form-group"
                         (setSliderValue)="setSliderValue($event)" (moveTop)="moveTop($event)"></div> -->

                    <div app-cea-slider-bootstrap
                         [sliderSettings]="BCUCoverageVariableSlider"
                         class="slider-container"
                         (setSliderValue)="setSliderValue($event)">                         
                    </div>

                    <!-- <div app-cea-slider [sliderSettings]="PersonalPropertyCoverageVariableSlider"
                         class="form-group" (moveTop)="moveTop($event)"
                         (setSliderValue)="setSliderValue($event,'PersonalPropertyCoverage')"></div> -->

                    <div app-cea-slider-bootstrap
                         [sliderSettings]="PersonalPropertyCoverageVariableSlider"
                         class="slider-container"
                         (setSliderValue)="setSliderValue($event,'PersonalPropertyCoverage')">                         
                    </div>

                    <!-- <div app-cea-slider [sliderSettings]="PersonalPropertyDeductibleVariableSlider"
                         class="form-group" (moveTop)="moveTop($event)" (moveTop)="moveTop($event)"
                         (setSliderValue)="setSliderValue($event,'PersonalPropertyDeductible')"
                         *ngIf="!showPersonalPropertyDeductibleVariableSliderFake"></div> -->

                    <div app-cea-slider-bootstrap
                         *ngIf="!showPersonalPropertyDeductibleVariableSliderFake"
                         [sliderSettings]="PersonalPropertyDeductibleVariableSlider"
                         class="slider-container"
                         (setSliderValue)="setSliderValue($event,'PersonalPropertyDeductible')">                         
                    </div>

                    <!-- <div app-cea-slider [sliderSettings]="PersonalPropertyDeductibleVariableSlider"
                         class="form-group" (moveTop)="moveTop($event)"
                         (setSliderValue)="setSliderValue($event,'PersonalPropertyDeductible')"
                         *ngIf="showPersonalPropertyDeductibleVariableSliderFake"></div> -->

                    <div app-cea-slider-bootstrap
                         *ngIf="showPersonalPropertyDeductibleVariableSliderFake"
                         [sliderSettings]="PersonalPropertyDeductibleVariableSlider"
                         class="slider-container"
                         (setSliderValue)="setSliderValue($event,'PersonalPropertyDeductible')">                         
                    </div>

                    <!-- <div app-cea-radio-group (setRadioValue)="setSliderValue($event)"
                         [radioGroupSettings]="WantsBreakableCoverageRadioGroup" (moveTop)="moveTop($event)"
                         *ngIf="!showWantsBreakableCoverageRadioGroupFake && !frfMode" class="form-group"></div> -->

                    <div app-cea-radio-group-bootstrap
                         *ngIf="!showWantsBreakableCoverageRadioGroupFake && !frfMode"
                         [radioGroupSettings]="WantsBreakableCoverageRadioGroup"
                         class="slider-container"
                         (setRadioValue)="setSliderValue($event)">                         
                    </div>

                    <!-- <div app-cea-radio-group (setRadioValue)="setSliderValue($event)"
                         [radioGroupSettings]="WantsBreakableCoverageRadioGroupFake"
                         (moveTop)="moveTop($event)" *ngIf="showWantsBreakableCoverageRadioGroupFake && !frfMode"
                         class="form-group"></div> -->

                    <div app-cea-radio-group-bootstrap
                         *ngIf="showWantsBreakableCoverageRadioGroupFake && !frfMode"
                         [radioGroupSettings]="WantsBreakableCoverageRadioGroupFake"
                         class="slider-container"
                         (setRadioValue)="setSliderValue($event)">                         
                    </div>

                    <!-- <div app-cea-slider [sliderSettings]="LossOfUseCoverageVariableSlider"
                         class="form-group" (setSliderValue)="setSliderValue($event)"
                         (moveTop)="moveTop($event)" *ngIf="!showLossOfUseCoverageVariableSlider1"></div> -->

                    <div app-cea-slider-bootstrap
                         *ngIf="!showLossOfUseCoverageVariableSlider1"
                         [sliderSettings]="LossOfUseCoverageVariableSlider"
                         class="slider-container"
                         (setSliderValue)="setSliderValue($event)">                         
                    </div>

                    <!-- <div app-cea-slider [sliderSettings]="LossOfUseCoverageVariableSlider1"
                         class="form-group" (setSliderValue)="setSliderValue($event)"
                         (moveTop)="moveTop($event)" *ngIf="showLossOfUseCoverageVariableSlider1"></div> -->

                    <div app-cea-slider-bootstrap
                         *ngIf="showLossOfUseCoverageVariableSlider1"
                         [sliderSettings]="LossOfUseCoverageVariableSlider1"
                         class="slider-container"
                         (setSliderValue)="setSliderValue($event)">                         
                    </div>

              </div>


               <div class="action-button-container mt-4 px-5">
                    <div class="row">
                         <div class="col-12 col-md-6">
                              <button class="btn btn-tertiary w-100 mb-4"
                                   id="btn-back"
                                   (click)="goBack()">
                                   <i class="fas fa-arrow-left" aria-hidden="true"></i>
                                   {{'GLOBAL.BACK_BUTTON' | translate}}                                   
                              </button>                              
                         </div>
                         <div class="col-12 col-md-6">
                              <button class="btn btn-danger w-100 mb-4"
                                   id="btn-start-over"
                                   (click)="startOver()">
                                   {{'COMPARE_SEND.CANCEL_BUTTON' | translate}}
                              </button>
                         </div>
                    </div>
                    <div class="row">
                         <div class="col-12 col-md-6">
                              <button class="btn btn-tertiary w-100 mb-4"
                                   id="btn-download"
                                   (click)="download($event)"
                                   [disabled]="processing || showError">
                                   {{'COMPARE_SEND.DOWNLOAD_BUTTON' | translate }}
                              </button>
                         </div>
                         <div class="col-12 col-md-6">
                              <button class="btn btn-tertiary w-100 mb-4"
                                   id="btn-compare"
                                   (click)="compare($event)"
                                   [disabled]="processing || showError">
                                   {{'COMPARE_SEND.COMPARE_BUTTON' | translate}}
                              </button>
                         </div>
                    </div>                   
               </div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div  style="display: none">
      <div class="cea-visible-lg">
        LG
      </div>
      <div class="cea-visible-md">
        MD
      </div>
      <div class="cea-visible-sm">
        SM
      </div>
      <div class="cea-visible-xs">
        XS
      </div>
      <div class="cea-visible-xss cea-visible-xxs">
        XXS
      </div>
      {{screenWidth}}
    </div>
  </div>
</div>
